import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-teams.request',
    templateUrl: './teams.request.component.html',
    styleUrl: './teams.request.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TeamsRequestComponent {

}
